import React from "react";
import { IRoute } from "../utils/interfaces.util";

const footerRoutes: Array<IRoute> = [
    {
        name: 'about',
        url: '/about',
        isAuth: false,
        params: [],
        content: {}
    },
    {
        name: 'contact',
        url: '/contact',
        isAuth: false,
        params: [],
        content: {}
    },
]

export default footerRoutes;